import React, { useState, useEffect } from 'react';
import './PanelTransition.css';

const PanelTransition = ({
  children,
  isTransitioning,
  fromPosition,
  toPosition,
  duration = 300
}) => {
  const [transitionClass, setTransitionClass] = useState('');

  useEffect(() => {
    if (isTransitioning && fromPosition && toPosition) {
      // Start transition
      setTransitionClass(`transition-${fromPosition}-to-${toPosition}`);
      
      // Clear transition class after animation completes
      const timer = setTimeout(() => {
        setTransitionClass('');
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [isTransitioning, fromPosition, toPosition, duration]);

  return (
    <div 
      className={`panel-transition-container ${transitionClass}`}
      style={{
        '--transition-duration': `${duration}ms`
      }}
    >
      {children}
    </div>
  );
};

export default PanelTransition;